import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromPharmacy from '../reducer/pharmacy.reducer';

export const selectPharmacyFeature = createFeatureSelector<fromPharmacy.PharmacyState>(fromPharmacy.pharmacyFeatureKey);

const { selectAll } = fromPharmacy.pharmacyAdapter.getSelectors();

export const selectPharmacies = createSelector(selectPharmacyFeature, selectAll);

export const selectPatientPharmacies = createSelector(selectPharmacyFeature, state => state.patientPharmacies);

export const selectError = createSelector(selectPharmacyFeature, state => state.baseState.error);

export const selectIsLoading = createSelector(selectPharmacyFeature, state => state.baseState.isLoading);

export const selectPageNumber = createSelector(selectPharmacyFeature, state => state.baseState.pageNumber);

export const selectPharmacy = createSelector(selectPharmacyFeature, state => state.selectedPharmacy);

export const selectPharmacySearchParams = createSelector(selectPharmacyFeature, state => state.pharmacySearchParams);
